export default __webpack_public_path__ + "static/media/calories.25fef86e.svg";